import { Dropdown } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import withRoleCheck from "components/hocs/withRoleCheck";
import {
  DeleteCampaignTargetModal as _DeleteCampaignTargetModal,
  AssignUserModal as _AssignUserModal,
} from "routes/campaign/components/Modals";
import _CampaignStatusModal from "routes/campaign/components/CampaignStatusModal";

const DeleteCampaignTargetModal = withRoleCheck(_DeleteCampaignTargetModal, [
  ACL_RELATIONSHIPS.campaignTarget.delete,
]);
const AssignUserModal = withRoleCheck(_AssignUserModal, [
  ACL_RELATIONSHIPS.campaignTargetAssign.create,
]);
const CampaignStatusModal = withRoleCheck(_CampaignStatusModal, [
  ACL_RELATIONSHIPS.campaignTargetChangeStatus.edit,
]);

export function CampaignTargetTableActionsButton({
  selectedIds = [],
  selectedData = [],
  campaignId,
  effectiveDate,
  deleteManyCampaignTarget,
  invalidateData,
}) {
  const disableActions = selectedIds.length === 0;
  return (
    <Dropdown text="Actions" className="button mini" disabled={disableActions}>
      <Dropdown.Menu direction="left">
        <AssignUserModal
          campaignId={parseInt(campaignId)}
          campaignTargets={selectedIds}
          fetchCampaignTargets={invalidateData}
          assignedUserId={
            selectedIds.length === 1
              ? selectedData.find(
                  campaignTarget => campaignTarget.entity_id === selectedIds[0]
                )?.assigned_user_id
              : null
          }
        />
        <CampaignStatusModal
          campaignId={campaignId}
          trigger={<Dropdown.Item content={"Change Campaign Status"} />}
          entities={selectedData}
          updateData={invalidateData}
          effectiveDate={effectiveDate}
        />
        <DeleteCampaignTargetModal
          onConfirmDelete={() =>
            deleteManyCampaignTarget(campaignId, selectedIds)
          }
          menuTrigger
          modalMessage="Are you sure you want to delete these Campaign Targets?"
          noIcon
          buttonText="Remove from Campaign"
        />
      </Dropdown.Menu>
    </Dropdown>
  );
}
